module.exports = __webpack_public_path__ + "static/takealook-ea180d5db2d14f4fbfe2270f7be1847c.png";